let $ = jQuery;

import ScrollMagic from 'scrollmagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

let AnimationManager = require('../utilities/animation-manager');

let idOutcomes = '#homepage-patient-outcomes';

class HomepageOutcomes extends AnimationManager {

  constructor() {
    super();
    this.idOutcomes = idOutcomes;
    this.idOutcomesStaff = '#homepage-patient-outcomes-staff-';
    this.limit = 3;
  }

  createScenes() {

    let duration = 200;
    let offset = 0;

      for(let i = 1; i <= this.limit; i++) {

        new ScrollMagic.Scene({
            triggerElement: this.idOutcomes,
            offset: offset,
            duration: duration
          })
          .setTween(this.idOutcomesStaff + i, {
            right: -20,
            ease: Power1.easeInOut
          }) // trigger a TweenMax.to tween
          // .addIndicators({name: `${this.idOutcomes} (duration: ${duration})`}) // add indicators (requires plugin)
          .addTo(this.controller);

      }

  }

  destroyScenes() {
    super.destroyScenes();
    $(this.idOutcomesTop).removeAttr('style');
    for(let i = 1; i <= this.limit; i++) {
      $(this.idOutcomesStaff + i).removeAttr('style');
    }
  }

}

function init() {
  if($(idOutcomes).length) {
    let homepageOutcomes = new HomepageOutcomes();
  }
}

if(typeof Drupal === 'undefined') {

  // Initialize for Styleguide
  $(document).ready(() => {
    init();
  });

} else {

  // Export for Drupal
  module.exports = {
    attach: function (context, settings) {
      init();
    }
  };

}

